// extracted by mini-css-extract-plugin
export default {"section":"Reinforcement_section__LOob-","alerts":"Reinforcement_alerts__b5ufp","loadingWrapper":"Reinforcement_loadingWrapper__QrJxk","colMargin":"Reinforcement_colMargin__e1x2m"};